let roles = {
    SUPERADMIN: "SuperAdmin",
    ADMINISTRADOR: "Administrador",
    COORD: "Coordinador de Operaciones Drive",
    SUPERVISOR: "Supervisor de Operaciones Drive",
    OPERADOR: "Drive",
    BARISTA: "Barista",
    ASESOR: "Asesor",
    AUDITOR: "Auditor"
}

export default roles;

